export var iconAdd = {
  "id": "icon--add",
  "name": "icon--add",
  "tags": "icon--add",
  "styles": "",
  "viewBox": "0 0 24 24",
  "width": "24",
  "height": "24",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M14 0h-4v10H0v4h10v10h4V14h10v-4H14z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconAddGlyph = {
  "id": "icon--add--glyph",
  "name": "icon--add--glyph",
  "tags": "icon--add--glyph",
  "styles": "",
  "viewBox": "0 0 16 16",
  "width": "16",
  "height": "16",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zm4 9H9v3H7V9H4V7h3V4h2v3h3v2z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconAddOutline = {
  "id": "icon--add--outline",
  "name": "icon--add--outline",
  "tags": "icon--add--outline",
  "styles": "",
  "viewBox": "0 0 24 24",
  "width": "24",
  "height": "24",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M13 6h-2v5H6v2h5v5h2v-5h5v-2h-5z"
    }, {
      "d": "M12 2c5.5 0 10 4.5 10 10s-4.5 10-10 10S2 17.5 2 12 6.5 2 12 2zm0-2C5.4 0 0 5.4 0 12s5.4 12 12 12 12-5.4 12-12S18.6 0 12 0z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconApi = {
  "id": "icon--api",
  "name": "icon--api",
  "tags": "icon--api",
  "styles": "",
  "viewBox": "0 0 25 24",
  "width": "25",
  "height": "24",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M23.4 24H.6c-.3 0-.6-.3-.6-.6s.3-.6.6-.6h22.8c.3 0 .6.3.6.6s-.3.6-.6.6zM9.5 9.7c0 .3.1.4.3.4h.3v.8c-.2 0-.6.1-.8.1-.5 0-.8-.2-.9-.6-.4.4-1.1.6-1.7.6-.9 0-1.7-.5-1.7-1.5C5 8.3 6 8.1 6.9 8c.8-.2 1.5 0 1.5-.7 0-.6-.6-.7-1-.7-.6 0-1.1.3-1.1.8H5.2c.1-1.3 1.2-1.7 2.3-1.7 1 0 2 .4 2 1.5v2.5zM8.4 8.3c-.4.3-.9.3-1.4.3-.5.1-.9.3-.9.9 0 .5.6.6 1 .6.5 0 1.2-.3 1.2-1v-.8h.1zM11 6h1.1v.7c.3-.6.9-.8 1.6-.8 1.6 0 2.4 1.2 2.4 2.7 0 1.4-.7 2.6-2.2 2.6-.6 0-1.3-.2-1.7-.8v2.5H11V6zm2.5.8c-.9 0-1.4.7-1.4 1.8 0 1 .5 1.8 1.4 1.8 1 0 1.4-.9 1.4-1.8 0-1-.5-1.8-1.4-1.8zM17 4h1v1h-1V4zm0 2h1v5h-1V6z"
    }, {
      "d": "M22 1.2c.4 0 .8.3.8.8v14c0 .4-.3.8-.8.8H2c-.4 0-.8-.3-.8-.8V2c0-.4.3-.8.8-.8h20zM22 0H2C.9 0 0 .9 0 2v14c0 1.1.9 2 2 2h20c1.1 0 2-.9 2-2V2c0-1.1-.9-2-2-2z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconApis = {
  "id": "icon--apis",
  "name": "icon--apis",
  "tags": "icon--apis",
  "styles": "",
  "viewBox": "0 0 25 24",
  "width": "25",
  "height": "24",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M23.4 24H.6c-.3 0-.6-.3-.6-.6s.3-.6.6-.6h22.8c.3 0 .6.3.6.6s-.3.6-.6.6zM9.5 9.7c0 .3.1.4.3.4h.3v.8c-.2 0-.6.1-.8.1-.5 0-.8-.2-.9-.6-.4.4-1.1.6-1.7.6-.9 0-1.7-.5-1.7-1.5C5 8.3 6 8.1 6.9 8c.8-.2 1.5 0 1.5-.7 0-.6-.6-.7-1-.7-.6 0-1.1.3-1.1.8H5.2c.1-1.3 1.2-1.7 2.3-1.7 1 0 2 .4 2 1.5v2.5zM8.4 8.3c-.4.3-.9.3-1.4.3-.5.1-.9.3-.9.9 0 .5.6.6 1 .6.5 0 1.2-.3 1.2-1v-.8h.1zM11 6h1.1v.7c.3-.6.9-.8 1.6-.8 1.6 0 2.4 1.2 2.4 2.7 0 1.4-.7 2.6-2.2 2.6-.6 0-1.3-.2-1.7-.8v2.5H11V6zm2.5.8c-.9 0-1.4.7-1.4 1.8 0 1 .5 1.8 1.4 1.8 1 0 1.4-.9 1.4-1.8 0-1-.5-1.8-1.4-1.8zM17 4h1v1h-1V4zm0 2h1v5h-1V6z"
    }, {
      "d": "M22 1.2c.4 0 .8.3.8.8v14c0 .4-.3.8-.8.8H2c-.4 0-.8-.3-.8-.8V2c0-.4.3-.8.8-.8h20zM22 0H2C.9 0 0 .9 0 2v14c0 1.1.9 2 2 2h20c1.1 0 2-.9 2-2V2c0-1.1-.9-2-2-2z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconAppServices = {
  "id": "icon--app-services",
  "name": "icon--app-services",
  "tags": "icon--app-services",
  "styles": "",
  "viewBox": "0 0 24 24",
  "width": "24",
  "height": "24",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M12 1.2l10.5 5.7L12 12.8 1.5 7.1 12 1.2zM12 0c-.2 0-.4.1-.6.2L.4 6.3c-.6.4-.6 1.2 0 1.5l11 6c.2.1.4.1.5.1.2 0 .4-.1.6-.2l11-6.1c.6-.4.6-1.2 0-1.6l-11-6H12z"
    }, {
      "d": "M12.1 18.9c-.3 0-.5-.1-.8-.2L.7 12.8c-.5-.2-.7-.7-.7-1.1 0-.5.2-.9.7-1.2l.6-.4c.2-.2.5-.1.7.1.2.2.1.5-.1.7l-.6.4c-.3.1-.3.3-.3.4 0 .1 0 .2.2.3l10.6 5.9c.2.1.4.1.6 0l10.5-6c.2-.1.2-.3.2-.3 0-.1 0-.2-.2-.3l-.6-.3c-.2-.1-.4-.4-.2-.7.1-.2.4-.3.7-.2l.5.3c.5.3.7.7.7 1.2s-.2.9-.7 1.2l-10.5 6c-.2 0-.5.1-.7.1z"
    }, {
      "d": "M12.1 24c-.3 0-.5-.1-.8-.2L.7 17.9c-.5-.2-.7-.7-.7-1.2s.2-.9.7-1.2l.6-.4c.2-.2.5-.1.7.1.1.3 0 .6-.2.8l-.6.4c-.2.1-.2.3-.2.3 0 .1 0 .2.2.3l10.6 5.9c.2.1.4.1.6 0l10.5-6c.2-.1.2-.3.2-.3 0-.1 0-.2-.2-.3l-.6-.3c-.2-.1-.4-.4-.2-.7.1-.2.4-.3.7-.2l.5.3c.5.3.7.7.7 1.2s-.2.9-.7 1.2l-10.5 6c-.2.1-.5.2-.7.2z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconApplications = {
  "id": "icon--applications",
  "name": "icon--applications",
  "tags": "icon--applications",
  "styles": "",
  "viewBox": "0 0 23 23",
  "width": "23",
  "height": "23",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M5.8 1.2v4.7H1.2V1.2h4.6zM7 0H0v7h7V0zm6.8 1.2v4.7H9.2V1.2h4.6zM15 0H8v7h7V0zm6.8 1.2v4.7h-4.7V1.2h4.7zM23 0h-7v7h7V0zM5.8 9.2v4.7H1.2V9.2h4.6zM7 8H0v7h7V8zm6.8 1.2v4.7H9.2V9.2h4.6zM15 8H8v7h7V8zm6.8 1.2v4.7h-4.7V9.2h4.7zM23 8h-7v7h7V8zM5.8 17.2v4.7H1.2v-4.7h4.6zM7 16H0v7h7v-7zm6.8 1.2v4.7H9.2v-4.7h4.6zM15 16H8v7h7v-7zm6.8 1.2v4.7h-4.7v-4.7h4.7zM23 16h-7v7h7v-7z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconApps = {
  "id": "icon--apps",
  "name": "icon--apps",
  "tags": "icon--apps",
  "styles": "",
  "viewBox": "0 0 23 23",
  "width": "23",
  "height": "23",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M5.8 1.2v4.7H1.2V1.2h4.6zM7 0H0v7h7V0zm6.8 1.2v4.7H9.2V1.2h4.6zM15 0H8v7h7V0zm6.8 1.2v4.7h-4.7V1.2h4.7zM23 0h-7v7h7V0zM5.8 9.2v4.7H1.2V9.2h4.6zM7 8H0v7h7V8zm6.8 1.2v4.7H9.2V9.2h4.6zM15 8H8v7h7V8zm6.8 1.2v4.7h-4.7V9.2h4.7zM23 8h-7v7h7V8zM5.8 17.2v4.7H1.2v-4.7h4.6zM7 16H0v7h7v-7zm6.8 1.2v4.7H9.2v-4.7h4.6zM15 16H8v7h7v-7zm6.8 1.2v4.7h-4.7v-4.7h4.7zM23 16h-7v7h7v-7z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconArrowDown = {
  "id": "icon--arrow--down",
  "name": "icon--arrow--down",
  "tags": "icon--arrow--down",
  "styles": "",
  "viewBox": "0 0 14 16",
  "width": "14",
  "height": "16",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M8 12.6V0H6v12.7l-4.7-5L0 9l7 7 7-7-1.3-1.3z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconArrowLeft = {
  "id": "icon--arrow--left",
  "name": "icon--arrow--left",
  "tags": "icon--arrow--left",
  "styles": "",
  "viewBox": "0 0 16 14",
  "width": "16",
  "height": "14",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M3.4 8H16V6H3.3l5-4.7L7 0 0 7l7 7 1.3-1.3z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconArrowRight = {
  "id": "icon--arrow--right",
  "name": "icon--arrow--right",
  "tags": "icon--arrow--right",
  "styles": "",
  "viewBox": "0 0 16 14",
  "width": "16",
  "height": "14",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M12.6 6H0v2h12.7l-5 4.7L9 14l7-7-7-7-1.3 1.3z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconArrowUp = {
  "id": "icon--arrow--up",
  "name": "icon--arrow--up",
  "tags": "icon--arrow--up",
  "styles": "",
  "viewBox": "0 0 14 16",
  "width": "14",
  "height": "16",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M6 3.4V16h2V3.4l4.7 4.9L14 7 7 0 0 7l1.3 1.3z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconArrows = {
  "id": "icon--arrows",
  "name": "icon--arrows",
  "tags": "icon--arrows",
  "styles": "",
  "viewBox": "0 0 24 22",
  "width": "24",
  "height": "22",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M20 14V0h-4v14h-4l6 8 6-8zM4 8v14h4V8h4L6 0 0 8z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconAsleepGlyph = {
  "id": "icon--asleep--glyph",
  "name": "icon--asleep--glyph",
  "tags": "icon--asleep--glyph",
  "styles": "",
  "viewBox": "0 0 14 17",
  "width": "14",
  "height": "17",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M12.043 3.505c-1.5-2.3-4.1-3.6-6.8-3.5-.3 0-.5.1-.6.4-.1.2 0 .4.2.6.3.3.5.6.7.9 1.2 1.9 1.5 4.3.8 6.4-1 2.5-3.2 4.3-5.8 4.7-.2 0-.4.2-.5.4-.1.2 0 .4.1.6 1.5 1.3 3.4 2 5.3 2 .6 0 1.3-.1 1.9-.2 2.6-.7 4.6-2.5 5.6-5s.7-5.2-.9-7.3z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconBlockChain = {
  "id": "icon--block-chain",
  "name": "icon--block-chain",
  "tags": "icon--block-chain",
  "styles": "",
  "viewBox": "0 0 21 24",
  "width": "21",
  "height": "24",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M9.5 1c.9 0 1.5.7 1.5 1.5S10.4 4 9.5 4C8.7 4 8 3.3 8 2.5S8.7 1 9.5 1zm0-1C8.2 0 7 1.1 7 2.5S8.2 5 9.5 5 12 3.9 12 2.5 10.9 0 9.5 0zM17 4l-3 1.7v2.4L10.3 6 5 9v3.6l-2-1.1-3 1.7v3.5l3 1.7 3-1.7v-1.1l4.5 2.4 5-3v-4.9l1.5.9 3-1.7V5.8L17 4zm-6.7 3.2l3.8 2.1-3.5 1.8-4-1.8 3.7-2.1zM5 16.1l-2 1.2-2-1.1v-2.3l2-1.2 2 1.1v2.3zm1-5.9l4 1.8v4.6l-4-2.2v-4.2zm5 6.3V12l3.5-1.8v4.2L11 16.5zm8-7.8l-2 1.2-2-1.2V6.3l2-1.2 2 1.2v2.4zM2.5 4C3.4 4 4 4.7 4 5.5S3.4 7 2.5 7 1 6.3 1 5.5 1.7 4 2.5 4zm0-1C1.1 3 0 4.1 0 5.5S1.1 8 2.5 8 5 6.9 5 5.5 3.9 3 2.5 3zm9 17c.8 0 1.5.7 1.5 1.5s-.6 1.5-1.5 1.5-1.5-.7-1.5-1.5.7-1.5 1.5-1.5zm0-1C10.1 19 9 20.1 9 21.5s1.1 2.5 2.5 2.5 2.5-1.1 2.5-2.5-1.1-2.5-2.5-2.5zm7-3c.8 0 1.5.7 1.5 1.5s-.7 1.5-1.5 1.5-1.5-.7-1.5-1.5.7-1.5 1.5-1.5zm0-1c-1.4 0-2.5 1.1-2.5 2.5s1.1 2.5 2.5 2.5 2.5-1.1 2.5-2.5-1.1-2.5-2.5-2.5z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconCaretDown = {
  "id": "icon--caret--down",
  "name": "icon--caret--down",
  "tags": "icon--caret--down",
  "styles": "",
  "viewBox": "0 0 10 5",
  "width": "10",
  "height": "5",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M10 0L5 5 0 0z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconCaretLeft = {
  "id": "icon--caret--left",
  "name": "icon--caret--left",
  "tags": "icon--caret--left",
  "styles": "",
  "viewBox": "0 0 5 10",
  "width": "5",
  "height": "10",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M5 0L0 5l5 5z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconCaretRight = {
  "id": "icon--caret--right",
  "name": "icon--caret--right",
  "tags": "icon--caret--right",
  "styles": "",
  "viewBox": "0 0 5 10",
  "width": "5",
  "height": "10",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M0 0l5 5-5 5z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconCaretUp = {
  "id": "icon--caret--up",
  "name": "icon--caret--up",
  "tags": "icon--caret--up",
  "styles": "",
  "viewBox": "0 0 10 5",
  "width": "10",
  "height": "5",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M10 5L5 0 0 5z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconCfApps = {
  "id": "icon--cf-apps",
  "name": "icon--cf-apps",
  "tags": "icon--cf-apps",
  "styles": "",
  "viewBox": "0 0 24 18",
  "width": "24",
  "height": "18",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M12.2 10.5c-.1-.5-.6-.9-1.2-.9-1.1 0-1.5.9-1.5 1.9 0 .9.4 1.8 1.5 1.8.7 0 1.1-.5 1.2-1.2h1.2c-.1 1.4-1 2.2-2.4 2.2-1.7 0-2.7-1.3-2.7-2.8 0-1.6 1-2.9 2.7-2.9 1.2 0 2.2.7 2.3 2h-1.1v-.1zm1.9-1.8h3.8v1h-2.6V11h2.3v.9h-2.3v2.2h-1.2V8.7z"
    }, {
      "d": "M13.6 1.2c3 0 5.4 2.4 5.5 5.4v.8l.7.3c1.8.7 2.9 2.4 2.9 4.4 0 2.6-2 4.7-4.5 4.7H5.6c-2.5-.1-4.5-2.2-4.5-4.7 0-2.6 2.1-4.8 4.7-4.8.3 0 .6 0 .9.1l1.3.2.1-1.3c.3-2.9 2.6-5.1 5.5-5.1zm0-1.2c-3.5 0-6.4 2.7-6.7 6.2-.3-.1-.7-.1-1-.1C2.6 6.1 0 8.7 0 12c0 3.2 2.5 5.8 5.6 5.9h12.7c3.2 0 5.7-2.6 5.7-5.9 0-2.5-1.5-4.6-3.7-5.5-.1-3.6-3.1-6.5-6.7-6.5z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconCheckmark = {
  "id": "icon--checkmark",
  "name": "icon--checkmark",
  "tags": "icon--checkmark",
  "styles": "",
  "viewBox": "0 0 12 9",
  "width": "12",
  "height": "9",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M4.1 6.1L1.4 3.4 0 4.9 4.1 9l7.6-7.6L10.3 0z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconCheckmarkGlyph = {
  "id": "icon--checkmark--glyph",
  "name": "icon--checkmark--glyph",
  "tags": "icon--checkmark--glyph",
  "styles": "",
  "viewBox": "0 0 16 16",
  "width": "16",
  "height": "16",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zM6.7 11.5L3.4 8.1l1.4-1.4 1.9 1.9 4.1-4.1 1.4 1.4-5.5 5.6z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconCheckmarkOutline = {
  "id": "icon--checkmark--outline",
  "name": "icon--checkmark--outline",
  "tags": "icon--checkmark--outline",
  "styles": "",
  "viewBox": "0 0 24 24",
  "width": "24",
  "height": "24",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M12 2c5.5 0 10 4.5 10 10s-4.5 10-10 10S2 17.5 2 12 6.5 2 12 2zm0-2C5.4 0 0 5.4 0 12s5.4 12 12 12 12-5.4 12-12S18.6 0 12 0z"
    }, {
      "d": "M10.3 13.6L7.7 11l-1.4 1.4 4 4L17.8 9l-1.4-1.4z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconChevronDown = {
  "id": "icon--chevron--down",
  "name": "icon--chevron--down",
  "tags": "icon--chevron--down",
  "styles": "",
  "viewBox": "0 0 12 8",
  "width": "12",
  "height": "8",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M10.6 0L6 4.7 1.4 0 0 1.4l6 6.1 6-6.1z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconChevronLeft = {
  "id": "icon--chevron--left",
  "name": "icon--chevron--left",
  "tags": "icon--chevron--left",
  "styles": "",
  "viewBox": "0 0 8 12",
  "width": "8",
  "height": "12",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M7.5 10.6L2.8 6l4.7-4.6L6.1 0 0 6l6.1 6z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconChevronRight = {
  "id": "icon--chevron--right",
  "name": "icon--chevron--right",
  "tags": "icon--chevron--right",
  "styles": "",
  "viewBox": "0 0 8 12",
  "width": "8",
  "height": "12",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M0 10.6L4.7 6 0 1.4 1.4 0l6.1 6-6.1 6z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconChevronUp = {
  "id": "icon--chevron--up",
  "name": "icon--chevron--up",
  "tags": "icon--chevron--up",
  "styles": "",
  "viewBox": "0 0 12 8",
  "width": "12",
  "height": "8",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M1.4 7.5L6 2.8l4.6 4.7L12 6.1 6 0 0 6.1z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconClose = {
  "id": "icon--close",
  "name": "icon--close",
  "tags": "icon--close",
  "styles": "",
  "viewBox": "0 0 10 10",
  "width": "10",
  "height": "10",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M9.8 8.6L8.4 10 5 6.4 1.4 10 0 8.6 3.6 5 .1 1.4 1.5 0 5 3.6 8.6 0 10 1.4 6.4 5z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconCloseGlyph = {
  "id": "icon--close--glyph",
  "name": "icon--close--glyph",
  "tags": "icon--close--glyph",
  "styles": "",
  "viewBox": "0 0 16 16",
  "width": "16",
  "height": "16",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zm3.5 10.1l-1.4 1.4L8 9.4l-2.1 2.1-1.4-1.4L6.6 8 4.5 5.9l1.4-1.4L8 6.6l2.1-2.1 1.4 1.4L9.4 8l2.1 2.1z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconCloseOutline = {
  "id": "icon--close--outline",
  "name": "icon--close--outline",
  "tags": "icon--close--outline",
  "styles": "",
  "viewBox": "0 0 24 24",
  "width": "24",
  "height": "24",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M17.1 15.8l-1.5 1.5-3.7-3.8-3.8 3.8-1.5-1.5 3.8-3.8-3.7-3.8 1.5-1.5 3.8 3.8 3.9-3.8 1.5 1.5-4 3.8z"
    }, {
      "d": "M12 2c5.5 0 10 4.5 10 10s-4.5 10-10 10S2 17.5 2 12 6.5 2 12 2zm0-2C5.4 0 0 5.4 0 12s5.4 12 12 12 12-5.4 12-12S18.6 0 12 0z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconCloudFoundry = {
  "id": "icon--cloud-foundry",
  "name": "icon--cloud-foundry",
  "tags": "icon--cloud-foundry",
  "styles": "",
  "viewBox": "0 0 24 18",
  "width": "24",
  "height": "18",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M12.2 10.5c-.1-.5-.6-.9-1.2-.9-1.1 0-1.5.9-1.5 1.9 0 .9.4 1.8 1.5 1.8.7 0 1.1-.5 1.2-1.2h1.2c-.1 1.4-1 2.2-2.4 2.2-1.7 0-2.7-1.3-2.7-2.8 0-1.6 1-2.9 2.7-2.9 1.2 0 2.2.7 2.3 2h-1.1v-.1zm1.9-1.8h3.8v1h-2.6V11h2.3v.9h-2.3v2.2h-1.2V8.7z"
    }, {
      "d": "M13.6 1.2c3 0 5.4 2.4 5.5 5.4v.8l.7.3c1.8.7 2.9 2.4 2.9 4.4 0 2.6-2 4.7-4.5 4.7H5.6c-2.5-.1-4.5-2.2-4.5-4.7 0-2.6 2.1-4.8 4.7-4.8.3 0 .6 0 .9.1l1.3.2.1-1.3c.3-2.9 2.6-5.1 5.5-5.1zm0-1.2c-3.5 0-6.4 2.7-6.7 6.2-.3-.1-.7-.1-1-.1C2.6 6.1 0 8.7 0 12c0 3.2 2.5 5.8 5.6 5.9h12.7c3.2 0 5.7-2.6 5.7-5.9 0-2.5-1.5-4.6-3.7-5.5-.1-3.6-3.1-6.5-6.7-6.5z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconConsole = {
  "id": "icon--console",
  "name": "icon--console",
  "tags": "icon--console",
  "styles": "",
  "viewBox": "0 0 24 24",
  "width": "24",
  "height": "24",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M0 0v24h24V0H0zm1 23V7h8v16H1zm22 0H10v-8h13v8zm0-9H10V7h13v7zM1 6V1h22v5H1z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconContainers = {
  "id": "icon--containers",
  "name": "icon--containers",
  "tags": "icon--containers",
  "styles": "",
  "viewBox": "0 0 24 24",
  "width": "24",
  "height": "24",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M21.7 5.8L13.5.4c-.9-.6-2.2-.6-3.1 0L2.2 5.9c-.4.3-.7.6-.9 1.1 0 0-.3.6-.3 1.3v7.6c0 .9.5 1.7 1.3 2.2l8.2 5.4c.5.3 1 .5 1.5.5s1.1-.2 1.6-.5l8.2-5.4c.8-.5 1.2-1.3 1.2-2.2V8.3c0-.3.1-1.5-1.3-2.5zm-18.9.9L11 1.3c.6-.4 1.4-.4 1.9 0l8.2 5.4c.3.2.6.5.7.9L16 11.2l-.4.3L13 9.6c-.6-.4-1.3-.4-1.9 0l-2.6 1.7-6.3-3.8c.1-.3.3-.6.6-.8zm11.9 5.4l-2.3 1.5c-.2.1-.5.1-.7 0L9.4 12l2.3-1.5c.2-.1.5-.1.7 0l2.3 1.6zm7.3 3.8c0 .6-.3 1.1-.8 1.4L13 22.7c-.6.4-1.4.4-1.9 0l-8.3-5.4C2.3 17 2 16.5 2 16V8.6l6.2 3.8 2.9 2c.6.4 1.3.4 1.9 0l2.9-1.9L22 8.6v7.3z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconCopy = {
  "id": "icon--copy",
  "name": "icon--copy",
  "tags": "icon--copy",
  "styles": "",
  "viewBox": "0 0 18 24",
  "width": "18",
  "height": "24",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M13 5V0H0v19h5v5h13V5h-5zM2 17V2h9v3H5v12H2zm14 5H7V7h9v15z"
    }, {
      "d": "M9 9h5v2H9zm0 3h5v2H9zm0 3h3v2H9z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconCopyGlyph = {
  "id": "icon--copy--glyph",
  "name": "icon--copy--glyph",
  "tags": "icon--copy--glyph",
  "styles": "",
  "viewBox": "0 0 14 16",
  "width": "14",
  "height": "16",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M10 4V0H0v12h4v4h10V4h-4zm-6 6H2V2h6v2H4v6zm8 4H6V6h6v8z"
    }, {
      "d": "M7 7h4v2H7zm0 3h4v2H7z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconCrash = {
  "id": "icon--crash",
  "name": "icon--crash",
  "tags": "icon--crash",
  "styles": "",
  "viewBox": "0 0 24 17",
  "width": "24",
  "height": "17",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M21 10l3 3-3 3v-2.5h-2.153A.986.986 0 0 1 18 14c-.086 0-.164-.028-.244-.05l-1.805 1.806c.023.08.05.158.05.244a1 1 0 1 1-2 0c0-.18.06-.342.146-.488L10.996 10a.988.988 0 0 1-.954-.792l-1.39-.464C8.475 8.898 8.25 9 8 9s-.476-.102-.65-.256l-1.392.464A.985.985 0 0 1 5 10a1 1 0 0 1-1-1c0-.038.018-.07.022-.108L1.392 6.92A1 1 0 1 1 2 6c0 .038-.018.07-.022.108l2.63 1.972a.978.978 0 0 1 1.042.176l1.392-.464A.985.985 0 0 1 8 7c.48 0 .86.343.958.792l1.39.464c.16-.14.36-.228.586-.242l3.24-6.482A.99.99 0 0 1 14 1a1 1 0 1 1 2 0c0 .14-.03.27-.08.393l1.97 2.627c.037-.002.07-.02.108-.02.366 0 .673.207.847.5H21V2l3 3-3 3V5.5h-2.153A.986.986 0 0 1 18 6a1 1 0 0 1-.92-1.393L15.108 1.98c-.014 0-.028.006-.043.006l-3.24 6.482c.1.156.175.332.175.532 0 .18-.06.342-.146.488L15.004 15c.086.002.16.03.24.05l1.805-1.806c-.023-.08-.05-.158-.05-.244a1 1 0 0 1 1-1c.365 0 .672.207.846.5H21V10z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconDashboard = {
  "id": "icon--dashboard",
  "name": "icon--dashboard",
  "tags": "icon--dashboard",
  "styles": "",
  "viewBox": "0 0 24 24",
  "width": "24",
  "height": "24",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M0 0v24h24V0H0zm1 23V7h8v16H1zm22 0H10v-8h13v8zm0-9H10V7h13v7zM1 6V1h22v5H1z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconData = {
  "id": "icon--data",
  "name": "icon--data",
  "tags": "icon--data",
  "styles": "",
  "viewBox": "0 0 24 24",
  "width": "24",
  "height": "24",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M0 0v24h24V0H0zm22.1 7l-7.2 8.9-9.2-3.8c-.2-.1-.4 0-.6.1L1 16.6V7h21.1zm.9 16H1v-4.9l4.6-5 9.2 3.8c.2.1.4 0 .6-.1L23 7.5V23zm0-17H1V1h22v5z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconDelete = {
  "id": "icon--delete",
  "name": "icon--delete",
  "tags": "icon--delete",
  "styles": "",
  "viewBox": "0 0 16 24",
  "width": "16",
  "height": "24",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M4 0h8v2H4zM0 3v4h1v17h14V7h1V3H0zm13 18H3V8h10v13z"
    }, {
      "d": "M5 10h2v9H5zm4 0h2v9H9z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconDeleteGlyph = {
  "id": "icon--delete--glyph",
  "name": "icon--delete--glyph",
  "tags": "icon--delete--glyph",
  "styles": "",
  "viewBox": "0 0 16 16",
  "width": "16",
  "height": "16",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M5 0h6v2H5zM2 3v3h1v10h10V6h1V3H2zm5 11H5V7h2v7zm4 0H9V7h2v7z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconDevices = {
  "id": "icon--devices",
  "name": "icon--devices",
  "tags": "icon--devices",
  "styles": "",
  "viewBox": "0 0 24 23",
  "width": "24",
  "height": "23",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M20.5 17c1.4 0 2.5 1.1 2.5 2.5S21.9 22 20.5 22h-17C2.1 22 1 20.9 1 19.5S2.1 17 3.5 17h17zm0-1h-17C1.6 16 0 17.6 0 19.5S1.6 23 3.5 23h17c1.9 0 3.5-1.6 3.5-3.5S22.4 16 20.5 16z"
    }, {
      "d": "M19.5 20h-15c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h15c.3 0 .5.2.5.5s-.2.5-.5.5zm1-11c1.4 0 2.5 1.1 2.5 2.5S21.9 14 20.5 14h-17C2.1 14 1 12.9 1 11.5S2.1 9 3.5 9h17zm0-1h-17C1.6 8 0 9.6 0 11.5S1.6 15 3.5 15h17c1.9 0 3.5-1.6 3.5-3.5S22.4 8 20.5 8z"
    }, {
      "d": "M19.5 12h-15c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h15c.3 0 .5.2.5.5s-.2.5-.5.5zm1-11C21.9 1 23 2.1 23 3.5S21.9 6 20.5 6h-17C2.1 6 1 4.9 1 3.5S2.1 1 3.5 1h17zm0-1h-17C1.6 0 0 1.6 0 3.5S1.6 7 3.5 7h17C22.4 7 24 5.4 24 3.5S22.4 0 20.5 0z"
    }, {
      "d": "M19.5 4h-15c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h15c.3 0 .5.2.5.5s-.2.5-.5.5z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconDevops = {
  "id": "icon--devops",
  "name": "icon--devops",
  "tags": "icon--devops",
  "styles": "",
  "viewBox": "0 0 24 24",
  "width": "24",
  "height": "24",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M21 13V3h-3v1h2v9h-3v11h7V13h-3zm2 10h-5v-9h5v9zM17 3.5L11 0v3H3v13h1V4h7v3l6-3.5zm-5-1.8l3 1.8-3 1.8V1.7zM16 20H6.4c-.3-1.4-1.6-2.5-3.2-2.5C1.4 17.5 0 19 0 20.7 0 22.5 1.5 24 3.2 24c1.7 0 3.1-1.3 3.2-3h9.5l.1-1zM3.2 23C2 23 1 22 1 20.7c0-1.2 1-2.2 2.2-2.2 1.2 0 2.2 1 2.2 2.2.1 1.3-.9 2.3-2.2 2.3z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconDollars = {
  "id": "icon--dollars",
  "name": "icon--dollars",
  "tags": "icon--dollars",
  "styles": "",
  "viewBox": "0 0 24 24",
  "width": "24",
  "height": "24",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M22.462 10.59l-3.404-9.04-6.834 2.61a1.745 1.745 0 0 0-1.002 2.243c.19.506.226 1.03.155 1.53a3.34 3.34 0 0 1 3.746 2.11c.655 1.742-.214 3.69-1.942 4.35l.503 1.332c.134-1.106.843-2.104 1.945-2.526l6.835-2.61zm-8.617 6.6c-.012-.032-.014-.062-.025-.09-.275.07-.553.12-.834.12a3.314 3.314 0 0 1-3.098-2.156c-.647-1.72.216-3.652 1.923-4.306L11.1 8.86a3.057 3.057 0 0 1-1.658 1.533l-7.9 3.02 3.4 9.038 7.903-3.02a1.742 1.742 0 0 0 1.002-2.24zm10.096-5.93a.673.673 0 0 1-.373.354l-7.46 2.852a1.712 1.712 0 0 0-.965.912 1.742 1.742 0 0 0-.038 1.33c.6 1.595-.2 3.383-1.783 3.988l-8.53 3.26a.658.658 0 0 1-.513-.016.672.672 0 0 1-.353-.376L.044 13.26a.682.682 0 0 1 .39-.874l8.53-3.26a1.744 1.744 0 0 0 1.002-2.24c-.6-1.597.2-3.385 1.782-3.99l7.46-2.852a.672.672 0 0 1 .868.393l3.88 10.303a.684.684 0 0 1-.015.52zm-5.75-1.625a1.515 1.515 0 0 0 1.958.888 1.534 1.534 0 0 0 .88-1.973 1.515 1.515 0 0 0-1.958-.886 1.533 1.533 0 0 0-.88 1.972zm.178-3.838a.678.678 0 0 0 .39-.873l-.72-1.912a.675.675 0 0 0-.868-.393.682.682 0 0 0-.39.873l.72 1.91a.68.68 0 0 0 .63.438.69.69 0 0 0 .238-.043zM6.06 14.123a1.516 1.516 0 0 0-1.958-.888 1.53 1.53 0 0 0-.88 1.972 1.513 1.513 0 0 0 1.956.888 1.53 1.53 0 0 0 .88-1.972zm.912 5.995a.678.678 0 0 1-.628.918.674.674 0 0 1-.628-.436l-.72-1.912a.68.68 0 0 1 .39-.874.675.675 0 0 1 .866.392l.72 1.912z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconDownload = {
  "id": "icon--download",
  "name": "icon--download",
  "tags": "icon--download",
  "styles": "",
  "viewBox": "0 0 24 24",
  "width": "24",
  "height": "24",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M19 9.4l-1.2-1.1L13 13V0h-2v13L6.2 8.3 5 9.4l7 6.6z"
    }, {
      "d": "M22 14v6H2v-6H0v10h24V14z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconDownloadGlyph = {
  "id": "icon--download--glyph",
  "name": "icon--download--glyph",
  "tags": "icon--download--glyph",
  "styles": "",
  "viewBox": "-1 2 16 16",
  "width": "16",
  "height": "16",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M8 9V2H6.1v7L3.5 6.5 2 8l5 5 5-5-1.5-1.5L8 9z"
    }, {
      "d": "M13 12v3H1v-3h-2v6h16v-6h-2z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconEdit = {
  "id": "icon--edit",
  "name": "icon--edit",
  "tags": "icon--edit",
  "styles": "",
  "viewBox": "0 0 29 29",
  "width": "29",
  "height": "29",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M20.297 2.932l2.9-2.9 5.806 5.805-2.9 2.9zM3.867 19.385l5.8 5.807 14.5-14.517-5.8-5.806-14.5 14.515zm5.8 3.07L6.6 19.384 18.367 7.607l3.066 3.068-11.766 11.78zM0 29.062l4.833-1.936-2.9-2.903z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconEditGlyph = {
  "id": "icon--edit--glyph",
  "name": "icon--edit--glyph",
  "tags": "icon--edit--glyph",
  "styles": "",
  "viewBox": "0 0 16 16",
  "width": "16",
  "height": "16",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M2.032 10.924l7.99-7.99 2.97 2.97-7.99 7.99zm9.014-8.91l1.98-1.98 2.97 2.97-1.98 1.98zM0 16l3-1-2-2z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconError = {
  "id": "icon--error",
  "name": "icon--error",
  "tags": "icon--error",
  "styles": "",
  "viewBox": "0 0 24 24",
  "width": "24",
  "height": "24",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M12 0C5.4 0 0 5.4 0 12s5.4 12 12 12 12-5.4 12-12S18.6 0 12 0zm0 22c-1.8 0-3.5-.5-5-1.4l.1-.1 12-15 .2-.4C21 7 22 9.4 22 12c0 5.5-4.5 10-10 10zm0-20c1.8 0 3.5.5 5 1.4v.1l-12 15-.2.4C3 17 2 14.6 2 12 2 6.5 6.5 2 12 2z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconErrorGlyph = {
  "id": "icon--error--glyph",
  "name": "icon--error--glyph",
  "tags": "icon--error--glyph",
  "styles": "",
  "viewBox": "0 0 16 16",
  "width": "16",
  "height": "16",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zM5.1 13.3L3.5 12 11 2.6l1.5 1.2-7.4 9.5z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconFavorite = {
  "id": "icon--favorite",
  "name": "icon--favorite",
  "tags": "icon--favorite",
  "styles": "",
  "viewBox": "0 0 16 15",
  "width": "16",
  "height": "15",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M8.11 11.75l-4.5 3.2c-.2.1-.5 0-.4-.3l1.5-5.1-4.6-3.2c-.2-.2-.1-.5.1-.5l5.5-.5 2-5.2c.1-.2.4-.2.5 0l2 5.2 5.5.5c.2 0 .3.3.1.4l-4.5 3.3 1.5 5.1c.1.2-.2.4-.4.3l-4.3-3.2z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconFilter = {
  "id": "icon--filter",
  "name": "icon--filter",
  "tags": "icon--filter",
  "styles": "",
  "viewBox": "0 0 24 24",
  "width": "24",
  "height": "24",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M10.9 3c-.4-1.7-2-3-3.9-3S3.6 1.3 3.1 3H0v2h3.1c.4 1.7 2 3 3.9 3s3.4-1.3 3.9-3H24V3H10.9zM7 5c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1zm10 3c-1.9 0-3.4 1.3-3.9 3H0v2h13.1c.4 1.7 2 3 3.9 3s3.4-1.3 3.9-3H24v-2h-3.1c-.5-1.7-2-3-3.9-3zm0 5c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1zM7 16c-1.9 0-3.4 1.3-3.9 3H0v2h3.1c.4 1.7 2 3 3.9 3s3.4-1.3 3.9-3H24v-2H10.9c-.5-1.7-2-3-3.9-3zm0 5c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconFilterGlyph = {
  "id": "icon--filter--glyph",
  "name": "icon--filter--glyph",
  "tags": "icon--filter--glyph",
  "styles": "",
  "viewBox": "0 0 16 16",
  "width": "16",
  "height": "16",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M5 0C3.7 0 2.6.8 2.2 2H0v2h2.2C2.6 5.2 3.7 6 5 6c1.3 0 2.4-.8 2.8-2H16V2H7.8C7.4.8 6.3 0 5 0zm0 4c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1zm0 6c-1.3 0-2.4.8-2.8 2H0v2h2.2c.4 1.2 1.5 2 2.8 2 1.3 0 2.4-.8 2.8-2H16v-2H7.8c-.4-1.2-1.5-2-2.8-2zm0 4c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1z"
    }, {
      "d": "M11 5c-1.3 0-2.4.8-2.8 2H0v2h8.2c.4 1.2 1.5 2 2.8 2 1.3 0 2.4-.8 2.8-2H16V7h-2.2c-.4-1.2-1.5-2-2.8-2zm0 4c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconFinance = {
  "id": "icon--finance",
  "name": "icon--finance",
  "tags": "icon--finance",
  "styles": "",
  "viewBox": "4 -4 24 24",
  "width": "24",
  "height": "24",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M21 14h1V4h-1v10zm3 0h1V4h-1v10zM27 .7L16-2.9 5 .7V2h22V.7zm1-.7v3H4V0l12-4 12 4zM5 19h22v-3H5v3zm23-3v3c0 .6-.4 1-1 1H5c-.6 0-1-.4-1-1v-3c0-.6.4-1 1-1h22c.6 0 1 .4 1 1zm-18-2h1V4h-1v10zm-3 0h1V4H7v10z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconFinancial = {
  "id": "icon--financial",
  "name": "icon--financial",
  "tags": "icon--financial",
  "styles": "",
  "viewBox": "4 -4 24 24",
  "width": "24",
  "height": "24",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M21 14h1V4h-1v10zm3 0h1V4h-1v10zM27 .7L16-2.9 5 .7V2h22V.7zm1-.7v3H4V0l12-4 12 4zM5 19h22v-3H5v3zm23-3v3c0 .6-.4 1-1 1H5c-.6 0-1-.4-1-1v-3c0-.6.4-1 1-1h22c.6 0 1 .4 1 1zm-18-2h1V4h-1v10zm-3 0h1V4H7v10z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconFolderGlyph = {
  "id": "icon--folder--glyph",
  "name": "icon--folder--glyph",
  "tags": "icon--folder--glyph",
  "styles": "",
  "viewBox": "0 0 16 12",
  "width": "16",
  "height": "12",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M0 12h16V2H8V0H0z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconFunctions = {
  "id": "icon--functions",
  "name": "icon--functions",
  "tags": "icon--functions",
  "styles": "",
  "viewBox": "0 0 25 25",
  "width": "25",
  "height": "25",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M14.3 24c-.2 0-.5-.2-.5-.4 0-.3.1-.5.4-.6 2.2-.4 4.2-1.4 5.8-3 4.1-4.1 4.2-10.6.4-14.9-.2-.2-.2-.5 0-.7.2-.2.5-.2.7 0 4.2 4.7 4 11.8-.5 16.2-1.6 1.8-3.8 3-6.3 3.4zM3.9 20.4c-.1 0-.3-.1-.4-.2C-.7 15.5-.5 8.4 4 4 5.8 2.2 8 1.1 10.5.7c.3 0 .5.1.6.4 0 .3-.1.5-.4.6-2.3.4-4.3 1.4-5.9 3-4.2 4-4.4 10.6-.6 14.8.2.2.2.5 0 .7-.1.1-.2.2-.3.2z"
    }, {
      "d": "M6.7 24.2c-.6 0-.9-.1-1-.1-.4-.1-.9-.4-.8-1.2.1-.8.5-1 1-1 2.6 0 3-2.8 3-9.3L6.2 12c-.9-.2-.9-1-.9-1.3 0-.4 0-1.2.9-1.4l2.9-.6C9.6 6 10.6 4 12.2 2.6 14.3.8 16.7.5 17.9.5c.6 0 1 .1 1 .1.5.1.8.5.7 1.2 0 .3-.1 1-.9 1-2 0-2.8 1.6-3 6l2.3.5c.9.2.9 1 .9 1.4 0 .4 0 1.2-.9 1.4l-2.4.5c0 4.4-1.1 7.6-3.4 9.6-1.8 1.7-4.3 2-5.5 2zM6 23.1c.5 0 3.4.3 5.8-1.8 2.1-1.8 3.1-4.9 3.1-9v-.6L18 11c.1-.1.1-.3.1-.4v-.4l-3.2-.6v-.4c.1-3.7.5-7.3 3.8-7.4v-.2H18c-1.1 0-3.3.2-5.1 1.8-1.5 1.3-2.5 3.3-2.9 5.9v.2l-3.6.8c-.1 0-.1.3-.1.4v.4l3.5.7v.8c0 5.2 0 10.2-4 10.3v.1c.1.1.1.1.2.1-.1 0-.1 0 0 0z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconGrid = {
  "id": "icon--grid",
  "name": "icon--grid",
  "tags": "icon--grid",
  "styles": "",
  "viewBox": "0 0 16 16",
  "width": "16",
  "height": "16",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M0 0h7v7H0zm9 0h7v7H9zM0 9h7v7H0zm9 0h7v7H9z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconHeaderContact = {
  "id": "icon--header--contact",
  "name": "icon--header--contact",
  "tags": "icon--header--contact",
  "styles": "",
  "viewBox": "0 0 12 12",
  "width": "12",
  "height": "12",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M10.563 1.4c-1-.9-2.2-1.4-3.5-1.4-1.3 0-2.5.5-3.4 1.4-.9.9-1.3 2-1.4 3.2-.5.1-1 .4-1.4.8-1.2 1.2-1.1 3 0 4.2.5.7 2.1 2.4 2.1 2.4v-1.5c.8 0 1.5-.3 2.1-.9.1-.1.1-.2.2-.2.5.2 1 .3 1.4.4V12l3.8-3.7c2-1.9 2-5 .1-6.9zm-1.1 5.9c-.6.6-1.5 1-2.4 1-.4 0-.8-.1-1.2-.2.2-.9-.1-1.9-.8-2.6-.4-.4-.8-.6-1.3-.8.1-.8.4-1.6 1-2.1.6-.6 1.5-1 2.4-1 .9 0 1.7.4 2.4 1 .6.6 1 1.5 1 2.4-.1.8-.5 1.6-1.1 2.3z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconHeaderDocs = {
  "id": "icon--header--docs",
  "name": "icon--header--docs",
  "tags": "icon--header--docs",
  "styles": "",
  "viewBox": "0 0 12 11",
  "width": "12",
  "height": "11",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M1 9V1h2.8S6 1 6 2.5v7.1S5.7 9 3.7 9H1zm6.5-9C6.4 0 6 .8 6 .8S5.6 0 3.8 0H0v10h3.7S6 10 6 11c0-1 2.2-1 2.2-1H12V0H7.5z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconHeaderHelp = {
  "id": "icon--header--help",
  "name": "icon--header--help",
  "tags": "icon--header--help",
  "styles": "",
  "viewBox": "0 0 12 12",
  "width": "12",
  "height": "12",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M6 0C2.7 0 0 2.7 0 6s2.7 6 6 6 6-2.7 6-6-2.7-6-6-6zm.8 10H5.2V8h1.5l.1 2zm-.1-3.4V7H5.3v-.5C5.5 4.9 6.9 5 6.8 4c.1-.6-.2-.9-.8-.9-.6 0-1 .6-1 1.3H3.6C3.7 3 4.6 2 6 2c1.8 0 2.4 1.1 2.4 1.8 0 1.9-1.6 1.6-1.7 2.8z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconHeaderNotifciation = {
  "id": "icon--header--notifciation",
  "name": "icon--header--notifciation",
  "tags": "icon--header--notifciation",
  "styles": "",
  "viewBox": "0 0 12 9",
  "width": "12",
  "height": "9",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M6 7.9H3v-2l3 .7v1.3zM12 0L1 3V2H0v4.9h1v-1h1v2.3c0 .4.3.8.8.8h3.5c.3-.1.7-.4.7-.9V6.9l5 1V0z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconHeaderTicket = {
  "id": "icon--header--ticket",
  "name": "icon--header--ticket",
  "tags": "icon--header--ticket",
  "styles": "",
  "viewBox": "0 0 14 14",
  "width": "14",
  "height": "14",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M5.5 3l3-3 1.4 1.4c-.8.8-.8 2 0 2.8.8.8 2 .8 2.8 0L14 5.6 5.6 14l-1.4-1.3c.8-.8.8-2 0-2.8-.8-.8-2-.8-2.8 0L0 8.5l5-5c0 .3.2.5.5.5s.5-.2.5-.5-.2-.5-.5-.5zm2 3c.3 0 .5-.2.5-.5S7.8 5 7.5 5s-.5.2-.5.5.2.5.5.5zm-1-1c.3 0 .5-.2.5-.5S6.8 4 6.5 4s-.5.2-.5.5.2.5.5.5zm2 2c.3 0 .5-.2.5-.5S8.8 6 8.5 6s-.5.2-.5.5.2.5.5.5zm1 1c.3 0 .5-.2.5-.5S9.8 7 9.5 7s-.5.2-.5.5.2.5.5.5zm1 1c.3 0 .5-.2.5-.5s-.2-.5-.5-.5-.5.2-.5.5.2.5.5.5z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconHelp = {
  "id": "icon--help",
  "name": "icon--help",
  "tags": "icon--help",
  "styles": "",
  "viewBox": "0 0 24 24",
  "width": "24",
  "height": "24",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M12 2c5.5 0 10 4.5 10 10s-4.5 10-10 10S2 17.5 2 12 6.5 2 12 2zm0-2C5.4 0 0 5.4 0 12s5.4 12 12 12 12-5.4 12-12S18.6 0 12 0z"
    }, {
      "d": "M8.3 10c.2-2 1.5-3.5 3.7-3.5 2.8 0 3.7 1.8 3.7 2.9 0 2.9-2.5 2.5-2.7 4.3V15h-2v-1c.2-2.6 2.4-2.8 2.3-4.4 0-.9-.5-1.3-1.3-1.3-1 0-1.5.8-1.5 1.7H8.3zm2.7 6h2v2h-2v-2z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconHelpGlyph = {
  "id": "icon--help--glyph",
  "name": "icon--help--glyph",
  "tags": "icon--help--glyph",
  "styles": "",
  "viewBox": "0 0 16 16",
  "width": "16",
  "height": "16",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zm.9 13H7v-1.8h1.9V13zm-.1-3.6v.5H7.1v-.6c.2-2.1 2-1.9 1.9-3.2.1-.7-.3-1.1-1-1.1-.8 0-1.2.7-1.2 1.6H5c0-1.7 1.2-3 2.9-3 2.3 0 3 1.4 3 2.3.1 2.3-1.9 2-2.1 3.5z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconHpa = {
  "id": "icon--hpa",
  "name": "icon--hpa",
  "tags": "icon--hpa",
  "styles": "",
  "viewBox": "0 0 24 22",
  "width": "24",
  "height": "22",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M21.992 18.666l-.03.04a5.48 5.48 0 0 1-4 2.27V16.04L18 16h4.974c-.088.988-.44 1.9-.982 2.666zm-8.004-7.385c.015-.01.026-.026.04-.04.052-.04.11-.072.162-.11A5.458 5.458 0 0 1 17.5 10c1.293 0 2.467.464 3.405 1.21.138.11.277.218.403.34.11.105.206.22.307.337.113.13.23.254.33.392.566.78.94 1.71 1.03 2.72h-5.267l-3.72-3.72zM17 16v4.975a5.504 5.504 0 0 1-4.125-2.506c-.035-.06-.065-.118-.1-.176a5.463 5.463 0 0 1 .495-6.307l.005-.006L17 15.708V16zm-9 1.973V12h4.028a6.48 6.48 0 0 0-.538 5.973H8zM1.027 11H7V5H1.027v6zm0 6.973H7V12H1.027v5.973zM8 5h6v5.028c-.433.278-.83.603-1.184.972H8V5zm12.972 0v5.012A6.456 6.456 0 0 0 17.5 9a6.5 6.5 0 0 0-2.5.5V5h5.972zM22 10.816V1a1 1 0 0 0-1-1H1a1 1 0 0 0-1 1v17a1 1 0 0 0 1 1h11.028a6.494 6.494 0 0 0 6.618 2.9c2.63-.448 4.764-2.556 5.242-5.18A6.494 6.494 0 0 0 22 10.816z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconHpaStress = {
  "id": "icon--hpa--stress",
  "name": "icon--hpa--stress",
  "tags": "icon--hpa--stress",
  "styles": "",
  "viewBox": "0 0 24 22",
  "width": "24",
  "height": "22",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M18 20.975V16h4.975A5.5 5.5 0 0 1 18 20.975zm-4.02-9.7A5.5 5.5 0 0 1 22.975 15h-5.268l-3.726-3.725zM17 16v4.975a5.498 5.498 0 0 1-3.726-8.993L17 15.707V16zM6.9 17.973L10 11H7V5l-4 9h3v3.973H1.027V5H14v5.03a6.486 6.486 0 0 0-2.51 7.943H6.9zM15 5h5.973v5.012A6.462 6.462 0 0 0 17.5 9c-.887 0-1.73.18-2.5.5V5zm7 5.817V1a1 1 0 0 0-1-1H1a1 1 0 0 0-1 1v17a1 1 0 0 0 1 1h5v1l.444-1h5.584a6.498 6.498 0 0 0 6.618 2.902c2.63-.45 4.764-2.558 5.243-5.18A6.5 6.5 0 0 0 22 10.817z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconInfo = {
  "id": "icon--info",
  "name": "icon--info",
  "tags": "icon--info",
  "styles": "",
  "viewBox": "0 0 24 24",
  "width": "24",
  "height": "24",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M12 2c5.5 0 10 4.5 10 10s-4.5 10-10 10S2 17.5 2 12 6.5 2 12 2zm0-2C5.4 0 0 5.4 0 12s5.4 12 12 12 12-5.4 12-12S18.6 0 12 0z"
    }, {
      "d": "M14 10H9v2h2v4H9v2h7v-2h-2zM11 7.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 1 1-3 0"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconInfoGlyph = {
  "id": "icon--info--glyph",
  "name": "icon--info--glyph",
  "tags": "icon--info--glyph",
  "styles": "",
  "viewBox": "0 0 16 16",
  "width": "16",
  "height": "16",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zm0 4c.6 0 1 .4 1 1s-.4 1-1 1-1-.4-1-1 .4-1 1-1zm2 8H6v-1h1V8H6V7h3v4h1v1z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconInfrastructure = {
  "id": "icon--infrastructure",
  "name": "icon--infrastructure",
  "tags": "icon--infrastructure",
  "styles": "",
  "viewBox": "0 0 24 24",
  "width": "24",
  "height": "24",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M14 1v22H1V1h13zm1-1H0v24h15V0zm8 1v22h-5V1h5zm1-1h-7v24h7V0z"
    }, {
      "d": "M12 4v4H3V4h9zm1-1H2v6h11V3zm8 0v1h-1V3h1zm1-1h-3v3h3V2zm-1 5v1h-1V7h1zm1-1h-3v3h3V6zm-1 5v1h-1v-1h1zm1-1h-3v3h3v-3zm-1 5v1h-1v-1h1zm1-1h-3v3h3v-3zm-1 5v1h-1v-1h1zm1-1h-3v3h3v-3z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconIntegration = {
  "id": "icon--integration",
  "name": "icon--integration",
  "tags": "icon--integration",
  "styles": "",
  "viewBox": "0 0 24 21",
  "width": "24",
  "height": "21",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M18 0H6L0 10.5 6 21h12l6-10.5L18 0zm4.5 10h-9.7l4.8-8.5 4.9 8.5zM6.3 19.4L1.4 11H11l-4.7 8.4zm5.6-7.8l4.8 8.4H7.2l4.7-8.4zm0-2.1L7 1h9.7l-4.8 8.5zM6.2 1.6L11 10H1.5l4.7-8.4zm11.5 18L12.8 11h9.8l-4.9 8.6z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconIot = {
  "id": "icon--iot",
  "name": "icon--iot",
  "tags": "icon--iot",
  "styles": "",
  "viewBox": "0 0 24 24",
  "width": "24",
  "height": "24",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M12 10c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zm0-1c-1.6 0-3 1.3-3 3s1.3 3 3 3 3-1.3 3-3-1.3-3-3-3z"
    }, {
      "d": "M17 7v10H7V7h10zm1-1H6v12h12V6zm-7-1h-1V2.1C10 1.5 9.5 1 8.9 1c-.6 0-.9.6-.9 1.1V5H7V2.1C7 .9 7.8 0 8.9 0H9c1.1 0 2 1 2 2.1V5zm6 0h-1V2.1c0-.6-.5-1.1-1.1-1.1-.6 0-.9.6-.9 1.1V5h-1V2.1c0-1.2.8-2.1 1.9-2.1h.1c1.1 0 2 1 2 2.1V5zm-1.9 19s-.1 0 0 0c-1.2 0-2.1-1-2.1-2.1V19h1v2.9c0 .6.5 1.1 1.1 1.1.7 0 .9-.6.9-1.1V19h1v2.9c0 1.2-.8 2.1-1.9 2.1zm-6 0s-.1 0 0 0C7.9 24 7 23 7 21.9V19h1v2.9c0 .6.5 1.1 1.1 1.1.7 0 .9-.6.9-1.1V19h1v2.9c0 1.2-.8 2.1-1.9 2.1zM5 17H2.1C.9 17 0 16.2 0 15.1c0-1.1 1-2 2.1-2H5v1H2.1c-.6-.1-1.1.4-1.1 1s.6.9 1.1.9H5v1zm0-6H2.1C.9 11 0 10.2 0 9.1c0-1.1 1-2 2.1-2H5v1H2.1C1.5 8 1 8.5 1 9.1s.6.9 1.1.9H5v1zm16.9 0H19v-1h2.9c.6 0 1.1-.4 1.1-1 0-.7-.6-1-1.1-1H19V7h2.9c1.2 0 2.1.8 2.1 1.9 0 1.2-1 2.1-2.1 2.1zm0 6H19v-1h2.9c.6 0 1.1-.5 1.1-1.1 0-.7-.6-.9-1.1-.9H19v-1h2.9c1.2 0 2.1.8 2.1 1.9 0 1.2-1 2.1-2.1 2.1z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconLaunch = {
  "id": "icon--launch",
  "name": "icon--launch",
  "tags": "icon--launch",
  "styles": "",
  "viewBox": "0 0 24 20",
  "width": "24",
  "height": "20",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M15.7 9.7L22 3.4V8h2V0h-8v2h4.6l-6.3 6.3z"
    }, {
      "d": "M22 18H2V4h10V0H0v20h24v-8h-2z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconLaunchGlyph = {
  "id": "icon--launch--glyph",
  "name": "icon--launch--glyph",
  "tags": "icon--launch--glyph",
  "styles": "",
  "viewBox": "-3 5 16 16",
  "width": "16",
  "height": "16",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M11 19H-1V9h3V5h-5v16h16v-5h-2z"
    }, {
      "d": "M4.7 14.7L11 8.4V13h2V5H5v2h4.6l-6.3 6.3z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconLight = {
  "id": "icon--light",
  "name": "icon--light",
  "tags": "icon--light",
  "styles": "",
  "viewBox": "0 0 18 18",
  "width": "18",
  "height": "18",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M9 0c.3 0 .6.3.6.6v2.5c0 .3-.3.6-.6.6s-.6-.3-.6-.6V.6c0-.3.3-.6.6-.6zm0 14.4c.3 0 .6.3.6.6v2.5c0 .3-.3.6-.6.6s-.6-.3-.6-.6V15c0-.4.3-.6.6-.6zM14.4 9c0-.3.3-.6.6-.6h2.5c.2.1.5.3.5.6s-.3.6-.6.6h-2.5c-.3 0-.5-.3-.5-.6zM0 9c0-.3.3-.6.6-.6h2.5c.3 0 .6.3.6.6s-.3.6-.6.6H.6C.3 9.6 0 9.3 0 9zm2.1-6.6c.2-.2.6-.2.8 0l1.8 1.8c.2.2.2.6 0 .8-.2.2-.6.2-.8 0L2.1 3.2c-.2-.2-.2-.6 0-.8zm11 2.6c-.2-.2-.2-.6 0-.8l1.8-1.8c.2-.2.6-.2.8 0 .2.2.2.6 0 .8L13.9 5c-.2.2-.6.2-.8 0zm2.6 10.7c-.2.2-.6.2-.8 0l-1.8-1.8c-.2-.2-.2-.6 0-.8.2-.2.6-.2.8 0l1.8 1.8c.2.2.2.6 0 .8zm-11-2.6c.2.2.2.6 0 .8l-1.8 1.8c-.2.2-.6.2-.8 0-.2-.2-.2-.6 0-.8l1.8-1.8c.2-.2.6-.2.8 0zM5 9a4 4 0 1 1 8 0 4 4 0 1 1-8 0"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconLightGlyph = {
  "id": "icon--light--glyph",
  "name": "icon--light--glyph",
  "tags": "icon--light--glyph",
  "styles": "",
  "viewBox": "0 0 18 18",
  "width": "18",
  "height": "18",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M9.1 18h-.2c-.5 0-.9-.4-.9-.9V15c0-.6.4-1 .9-1H9c.6 0 1 .4 1 .9V17c0 .6-.4 1-.9 1zm7-2.3c-.5.5-1 .5-1.4.1l-1.5-1.5c-.4-.4-.4-1 0-1.3l.1-.1c.4-.4 1-.4 1.3 0l1.5 1.5c.3.4.3 1 0 1.3zm-13.8.1c-.5-.5-.5-1-.1-1.4l1.5-1.5c.4-.4 1-.4 1.3 0l.1.1c.4.4.4 1 0 1.3l-1.5 1.5c-.4.4-1 .4-1.3 0zM8.9 0c.7 0 1.1.4 1.1.9V3c0 .6-.4 1-.9 1h-.2c-.5 0-.9-.4-.9-.9V.9c0-.5.4-.9.9-.9zM2.2 2.2c.5-.5 1-.5 1.4-.1l1.5 1.5c.4.4.4 1 0 1.3L5 5c-.4.4-1 .4-1.3 0L2.2 3.5c-.4-.4-.4-1 0-1.3zm13.7-.1c.5.5.5 1 .1 1.4L14.6 5c-.4.4-1 .4-1.3 0l-.1-.1c-.4-.4-.4-1 0-1.3l1.5-1.5c.2-.4.9-.4 1.2 0zM.1 9.1V9c0-.5.4-.9.9-.9h2.1c.6-.1 1 .3 1 .8V9c0 .6-.4 1-.9 1H1.1c-.6 0-1-.4-1-.9zm14 0V9c0-.5.4-.9.9-.9h2.1c.5 0 .9.4.9.9v.1c0 .5-.4.9-.9.9H15c-.6 0-.9-.4-.9-.9zM5.1 9a4 4 0 1 1 8 0 4 4 0 1 1-8 0"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconLink = {
  "id": "icon--link",
  "name": "icon--link",
  "tags": "icon--link",
  "styles": "",
  "viewBox": "0 0 24 24",
  "width": "24",
  "height": "24",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M22.3 1.7C21.2.7 19.8 0 18.2 0c-1.6 0-3.1.7-4.1 1.7l-2.5 2.5c-1.1 1.1-1.7 2.5-1.7 4.1 0 .6.1 1.2.3 1.8-.7-.2-1.2-.3-1.9-.3-1.6 0-3.1.7-4.1 1.7L1.7 14C.7 15.1 0 16.5 0 18.2c0 1.6.6 3.1 1.7 4.2 1 1 2.5 1.6 4.1 1.6 1.6 0 3.1-.7 4.1-1.7l2.5-2.5c1.1-1.1 1.7-2.5 1.7-4.1 0-.6-.1-1.2-.3-1.8.6.2 1.2.3 1.8.3 1.6 0 3.1-.7 4.1-1.7l2.5-2.5C23.3 8.9 24 7.5 24 5.8c0-1.6-.7-3-1.7-4.1zM10.9 18.2l-2.5 2.5c-.7.7-1.6 1.1-2.6 1.1s-2-.4-2.6-1c-.7-.7-1-1.6-1-2.6s.4-1.9 1.1-2.6l2.5-2.5c.6-.7 1.6-1.1 2.5-1.1.6 0 1.2.2 1.7.4l-3.2 3.2 1.5 1.5 3.2-3.2c.3.5.4 1.1.4 1.7.1 1-.3 2-1 2.6zm9.8-9.8l-2.5 2.5c-.7.7-1.6 1.1-2.6 1.1-.6 0-1.2-.2-1.7-.4l3.2-3.2-1.5-1.5-3.2 3.2c-.2-.6-.4-1.1-.4-1.8 0-1 .4-1.9 1.1-2.6l2.5-2.5c.7-.7 1.6-1.1 2.6-1.1s1.9.4 2.6 1.1c.7.7 1.1 1.6 1.1 2.6-.1 1-.5 1.9-1.2 2.6z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconList = {
  "id": "icon--list",
  "name": "icon--list",
  "tags": "icon--list",
  "styles": "",
  "viewBox": "0 0 16 14",
  "width": "16",
  "height": "14",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M0 0h16v2H0zm0 4h16v2H0zm0 4h16v2H0zm0 4h16v2H0z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconLocked = {
  "id": "icon--locked",
  "name": "icon--locked",
  "tags": "icon--locked",
  "styles": "",
  "viewBox": "0 0 18 24",
  "width": "18",
  "height": "24",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M15.5 6.5C15.5 3 12.5 0 9 0S2.5 3 2.5 6.5v3C1.1 11 .3 13 .3 15.3.3 20.1 4.2 24 9 24c4.8 0 8.7-3.9 8.7-8.7 0-2.2-.8-4.2-2.2-5.8v-3zm-10.9 0c0-2.3 2-4.4 4.4-4.4 2.4 0 4.4 2 4.4 4.4v1.2C12.1 7 10.6 6.5 9 6.5c-1.6 0-3.1.4-4.4 1.2V6.5zm2.8 13.6l-4-4 1.5-1.5 2.5 2.5 5.8-5.8 1.5 1.5-7.3 7.3z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconMenu = {
  "id": "icon--menu",
  "name": "icon--menu",
  "tags": "icon--menu",
  "styles": "",
  "viewBox": "0 0 20 14",
  "width": "20",
  "height": "14",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M0 0h20v2H0zm0 6h20v2H0zm0 6h20v2H0z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconMobile = {
  "id": "icon--mobile",
  "name": "icon--mobile",
  "tags": "icon--mobile",
  "styles": "",
  "viewBox": "0 0 24 24",
  "width": "24",
  "height": "24",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M23 0H1C.5 0 0 .5 0 1v21c0 .6.5 1 1 1h22c.6 0 1-.5 1-1V1c0-.5-.5-1-1-1zM1 1h7v3H1V1zm22 21H1V5h22v17zm0-21v3H9V1h14z"
    }, {
      "d": "M7.5 8h-5c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h5c.3 0 .5.2.5.5s-.2.5-.5.5zm3 3h-8c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h8c.3 0 .5.2.5.5s-.2.5-.5.5zm3-3h-4c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h4c.3 0 .5.2.5.5s-.2.5-.5.5zm1 3h-2c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h2c.3 0 .5.2.5.5s-.2.5-.5.5zm-10 3h-2c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h2c.3 0 .5.2.5.5s-.2.5-.5.5zm4 0h-1c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h1c.3 0 .5.2.5.5s-.2.5-.5.5zm11-3h-3c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h3c.3 0 .5.2.5.5s-.2.5-.5.5zM2 2.5a.5.5 0 1 1 1 0 .5.5 0 1 1-1 0M4 2.5a.5.5 0 1 1 1 0 .5.5 0 1 1-1 0M6 2.5a.5.5 0 1 1 1 0 .5.5 0 1 1-1 0"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconNetwork = {
  "id": "icon--network",
  "name": "icon--network",
  "tags": "icon--network",
  "styles": "",
  "viewBox": "0 0 23 24",
  "width": "23",
  "height": "24",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M20.5 18v-6h-9V5.9C12.9 5.7 14 4.5 14 3c0-1.7-1.3-3-3-3S8 1.3 8 3c0 1.5 1.1 2.7 2.5 2.9V12h-8v6.1C1.1 18.4 0 19.6 0 21c0 1.7 1.3 3 3 3s3-1.3 3-3c0-1.5-1.1-2.7-2.5-2.9V13h16v5.1c-1.4.2-2.5 1.5-2.5 2.9 0 1.7 1.3 3 3 3s3-1.3 3-3c0-1.5-1-2.8-2.5-3zM9 3c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2-2-.9-2-2zM5 21c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2zm15 2c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconOpenWhisk = {
  "id": "icon--open-whisk",
  "name": "icon--open-whisk",
  "tags": "icon--open-whisk",
  "styles": "",
  "viewBox": "0 0 25 16",
  "width": "25",
  "height": "16",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M9.9 9.7L4.5 0 0 8l4.5 8h8l.5-.8 3-5.5H9.9zm-4.7 5.1L1.4 8l3.1-5.5 6.9 12.3H5.2zm7.2-1.1l-1.6-2.8h3.1l-1.5 2.8z"
    }, {
      "d": "M19.5 0h-7.8l-.6 1.1-3 5.5h6l5.3 9.5L24 8l-4.5-8zm-9.3 5.3l1.5-2.8 1.6 2.8h-3.1zm2.4-4.1h6.2L22.6 8l-3.1 5.5-6.9-12.3z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconOverflowMenu = {
  "id": "icon--overflow-menu",
  "name": "icon--overflow-menu",
  "tags": "icon--overflow-menu",
  "styles": "",
  "viewBox": "0 0 4 20",
  "width": "4",
  "height": "20",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M0 2a2 2 0 1 1 4 0 2 2 0 1 1-4 0M0 10a2 2 0 1 1 4 0 2 2 0 1 1-4 0M0 18a2 2 0 1 1 4 0 2 2 0 1 1-4 0"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconPa = {
  "id": "icon--pa",
  "name": "icon--pa",
  "tags": "icon--pa",
  "styles": "",
  "viewBox": "0 0 24 24",
  "width": "24",
  "height": "24",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M22.588 12.982L10.643 1h-6.23L1 4.406v6.265L13.004 22.59l9.584-9.605zm1.412 0L13.008 24 0 11.087V3.99L4 0h7.058L24 12.982zM9 7a2 2 0 1 1-4 0 2 2 0 0 1 4 0z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconPaStress = {
  "id": "icon--pa--stress",
  "name": "icon--pa--stress",
  "tags": "icon--pa--stress",
  "styles": "",
  "viewBox": "0 0 24 24",
  "width": "24",
  "height": "24",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M22.588 12.982l-3.937-3.95L16 15V9h-3l1.733-3.898L10.643 1h-6.23L1 4.406v6.265L13.004 22.59l9.584-9.605zm1.412 0L13.008 24 0 11.087V3.99L4 0h7.058l4.11 4.123L17 0v5.96l.04.04H20l-.913 2.053L24 12.983zM9 7a2 2 0 1 1-4 0 2 2 0 0 1 4 0z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconPause = {
  "id": "icon--pause",
  "name": "icon--pause",
  "tags": "icon--pause",
  "styles": "",
  "viewBox": "0 0 24 24",
  "width": "24",
  "height": "24",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M0 0h9v24H0zm15 0h9v24h-9z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconPauseGlyph = {
  "id": "icon--pause--glyph",
  "name": "icon--pause--glyph",
  "tags": "icon--pause--glyph",
  "styles": "",
  "viewBox": "0 0 16 16",
  "width": "16",
  "height": "16",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zM7 11H5V5h2v6zm4 0H9V5h2v6z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconPauseOutline = {
  "id": "icon--pause--outline",
  "name": "icon--pause--outline",
  "tags": "icon--pause--outline",
  "styles": "",
  "viewBox": "0 0 24 24",
  "width": "24",
  "height": "24",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M12 2c5.5 0 10 4.5 10 10s-4.5 10-10 10S2 17.5 2 12 6.5 2 12 2zm0-2C5.4 0 0 5.4 0 12s5.4 12 12 12 12-5.4 12-12S18.6 0 12 0z"
    }, {
      "d": "M8 8h3v8H8zm5 0h3v8h-3z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconPlay = {
  "id": "icon--play",
  "name": "icon--play",
  "tags": "icon--play",
  "styles": "",
  "viewBox": "0 0 21 24",
  "width": "21",
  "height": "24",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M0 24l21-12L0 0z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconPlayGlyph = {
  "id": "icon--play--glyph",
  "name": "icon--play--glyph",
  "tags": "icon--play--glyph",
  "styles": "",
  "viewBox": "0 0 16 16",
  "width": "16",
  "height": "16",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zM5 11V5l6.6 3L5 11z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconPlayOutline = {
  "id": "icon--play--outline",
  "name": "icon--play--outline",
  "tags": "icon--play--outline",
  "styles": "",
  "viewBox": "0 0 24 24",
  "width": "24",
  "height": "24",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M8 17l9-5-9-5z"
    }, {
      "d": "M12 2c5.5 0 10 4.5 10 10s-4.5 10-10 10S2 17.5 2 12 6.5 2 12 2zm0-2C5.4 0 0 5.4 0 12s5.4 12 12 12 12-5.4 12-12S18.6 0 12 0z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconPortfolio = {
  "id": "icon--portfolio",
  "name": "icon--portfolio",
  "tags": "icon--portfolio",
  "styles": "",
  "viewBox": "0 0 24 20",
  "width": "24",
  "height": "20",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M7 5H6V1a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v4h-1V1H7v4zM1 19h22V7H1v12zM23 6H1a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h22a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconPower = {
  "id": "icon--power",
  "name": "icon--power",
  "tags": "icon--power",
  "styles": "",
  "viewBox": "0 0 20 24",
  "width": "20",
  "height": "24",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M12.2 4.6L12 4V0H8v4l-.2.6C3.4 5.6.2 9.5.2 14.2.2 19.7 4.6 24 10 24s9.8-4.4 9.8-9.8c0-4.7-3.3-8.6-7.6-9.6zM10 21.8c-4.3 0-7.6-3.4-7.6-7.6 0-3.5 2.2-6.3 5.5-7.3L8 7v7h4V7l.2-.1c3.3 1 5.5 3.8 5.5 7.3-.1 4.2-3.4 7.6-7.7 7.6z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconPowerGlyph = {
  "id": "icon--power--glyph",
  "name": "icon--power--glyph",
  "tags": "icon--power--glyph",
  "styles": "",
  "viewBox": "0 0 14 16",
  "width": "14",
  "height": "16",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M9 2.3V0H5v2.3C2.1 3.2 0 5.8 0 9c0 3.9 3.1 7 7 7s7-3.1 7-7c0-3.2-2.1-5.8-5-6.7zM7 14c-2.8 0-5-2.2-5-5 0-2 1.2-3.8 3-4.6V9h4V4.4c1.8.8 3 2.6 3 4.6 0 2.8-2.2 5-5 5z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconPredictive = {
  "id": "icon--predictive",
  "name": "icon--predictive",
  "tags": "icon--predictive",
  "styles": "",
  "viewBox": "0 0 24 18",
  "width": "24",
  "height": "18",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M6 9h1V8H6v1zM4 9h1V8H4v1zm-1-.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zM13 12a3 3 0 1 1 0-6 3 3 0 0 1 0 6zm9.5-5a1.5 1.5 0 0 0-1.408 1h-4.234a3.968 3.968 0 0 0-.85-1.61l2.274-3.41c.072.008.144.02.218.02A1.5 1.5 0 1 0 17 1.5c0 .39.152.74.395 1.007l-2.132 3.198A3.978 3.978 0 0 0 13 5a3.988 3.988 0 0 0-3.858 3H8v1h1a4 4 0 0 0 6.263 3.295l2.132 3.198A1.49 1.49 0 0 0 17 16.5a1.5 1.5 0 1 0 1.5-1.5c-.074 0-.146.012-.218.02l-2.274-3.41c.61-.702.992-1.607.992-2.61h4.092c.207.58.756 1 1.408 1a1.5 1.5 0 0 0 0-3z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconPurchase = {
  "id": "icon--purchase",
  "name": "icon--purchase",
  "tags": "icon--purchase",
  "styles": "",
  "viewBox": "0 0 24 17",
  "width": "24",
  "height": "17",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M0 0v17h24V0H0zm22 15H2V8h20v7zM2 4V2h20v2H2z"
    }, {
      "d": "M3 13h4v1H3zm5 0h5v1H8z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconRestart = {
  "id": "icon--restart",
  "name": "icon--restart",
  "tags": "icon--restart",
  "styles": "",
  "viewBox": "0 0 18 24",
  "width": "18",
  "height": "24",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M10.9 9.5l1.3 1.3 2.4-2.4L16 7l1.6-1.6L12.2 0l-1.3 1.3 3.3 3.1H9.5c-2.2 0-4.2.8-5.8 2C1.5 8.1 0 10.8 0 13.9c0 5.2 4.3 9.5 9.5 9.5 2.4 0 4.5-.9 6.2-2.3l-1.4-1.4c-1.3 1.1-3 1.7-4.8 1.7C5.4 21.4 2 18 2 13.9s3.4-7.5 7.5-7.5h4.8l-1.1 1-2.3 2.1z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconRestartGlyph = {
  "id": "icon--restart--glyph",
  "name": "icon--restart--glyph",
  "tags": "icon--restart--glyph",
  "styles": "",
  "viewBox": "0 0 12 16",
  "width": "12",
  "height": "16",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M6 8l1.3 1.3 1.9-1.9L10.6 6 12 4.7 7.3 0 6 1.2l2.6 2.4H5.9c-1.7 0-3.3.8-4.4 2C.5 6.7 0 8.1 0 9.6c0 3.3 2.7 6 6 6 1.6 0 3-.6 4-1.6l-1.4-1.4c-.7.6-1.6 1-2.6 1-2.2 0-4-1.8-4-4s1.8-4 4-4h2.8l-.6.6L6 8z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconSchematics = {
  "id": "icon--schematics",
  "name": "icon--schematics",
  "tags": "icon--schematics",
  "styles": "",
  "viewBox": "0 0 24 24",
  "width": "24",
  "height": "24",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M22.26 11.576L19.2 9.694c1.882-1.082 3.53-2.023 3.67-2.118a.494.494 0 0 0 .236-.423.494.494 0 0 0-.235-.424A2472.813 2472.813 0 0 0 12.99.705C12.94.66 12.94.66 12.894.66 12.47.423 12 .423 11.53.564c-.376.14-.705.33-.988.517-.14.047-6.117 3.765-8.094 4.99l-.66.422a2.054 2.054 0 0 0-.61.424c-.848.94-.895 2.682-.518 4 .188.517.423 1.035.706 1.41.376.425.753.707 1.176.943l.094.048c.283.188 8.94 5.082 9.318 5.27.047.047.66.424.66 1.883 0 .283.187.47.47.47.282 0 .47-.187.47-.47 0-2.023-1.035-2.635-1.13-2.682a1749.31 1749.31 0 0 1-9.317-5.27l-.094-.047c-.33-.235-.66-.423-.847-.752-.236-.283-.377-.66-.518-1.083-.282-1.035-.282-2.447.33-3.106.094-.095.188-.14.33-.236l.658-.423c7.106-4.376 8.047-4.988 8.094-4.988.235-.188.47-.33.753-.423.282-.095.47-.048.706.046h.046c.47.33 5.788 3.53 9.176 5.553-2.26 1.316-9.317 5.316-9.553 5.458a.54.54 0 0 1-.47 0c-.237-.142-6.025-3.483-8.237-4.753-.235-.094-.517-.047-.658.188-.142.188-.048.518.14.612.33.188 8 4.61 8.33 4.847.424.235.94.235 1.365 0 .188-.094 3.012-1.74 5.647-3.247l3.53 2.164c.093.046 1.27.705 1.27 2.26 0 1.692-.47 2.022-1.224 2.634-.047 0-1.223.752-8.47 5.223l-.33.188c-.33.236-.847.518-1.082.424-.234-.142-4.046-2.495-10.023-6.12l1.6-.987a.507.507 0 0 0 .142-.66c-.143-.234-.425-.33-.66-.187L.8 16.47a.562.562 0 0 0-.235.423c0 .188.094.33.235.424l.14.094c10.4 6.354 10.59 6.448 10.636 6.495.142.094.33.094.518.094.518 0 1.082-.283 1.46-.47l.33-.19c8.47-5.27 8.47-5.27 8.516-5.27.847-.66 1.6-1.224 1.6-3.39 0-2.116-1.6-3.01-1.74-3.105z"
    }, {
      "d": "M5.694 7.247a.488.488 0 0 0 .565.377l4.61-.753-1.035 2.59c-.094.234.047.516.283.61.047.048.14.048.188.048.188 0 .376-.142.423-.283l1.694-4.188L6.07 6.682c-.236.047-.424.33-.377.565zm12.47-1.082a.507.507 0 0 0-.658-.14l-3.012 1.834a.507.507 0 0 0-.14.658c.046.094.14.14.234.188.14.047.33 0 .424-.047l3.012-1.836a.507.507 0 0 0 .14-.66z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconSearch = {
  "id": "icon--search",
  "name": "icon--search",
  "tags": "icon--search",
  "styles": "",
  "viewBox": "0 0 25 25",
  "width": "25",
  "height": "25",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M16.036 18.455l2.404-2.405 5.586 5.587-2.404 2.404zM8.5 2C12.1 2 15 4.9 15 8.5S12.1 15 8.5 15 2 12.1 2 8.5 4.9 2 8.5 2zm0-2C3.8 0 0 3.8 0 8.5S3.8 17 8.5 17 17 13.2 17 8.5 13.2 0 8.5 0zM15 16a1 1 0 1 1 2 0 1 1 0 1 1-2 0"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconSearchGlyph = {
  "id": "icon--search--glyph",
  "name": "icon--search--glyph",
  "tags": "icon--search--glyph",
  "styles": "",
  "viewBox": "0 0 16 16",
  "width": "16",
  "height": "16",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M6 2c2.2 0 4 1.8 4 4s-1.8 4-4 4-4-1.8-4-4 1.8-4 4-4zm0-2C2.7 0 0 2.7 0 6s2.7 6 6 6 6-2.7 6-6-2.7-6-6-6zm10 13.8L13.8 16l-3.6-3.6 2.2-2.2z"
    }, {
      "d": "M16 13.8L13.8 16l-3.6-3.6 2.2-2.2z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconSecurity = {
  "id": "icon--security",
  "name": "icon--security",
  "tags": "icon--security",
  "styles": "",
  "viewBox": "0 0 16 24",
  "width": "16",
  "height": "24",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M13 9.8V5c0-2.8-2.2-5-5-5S3 2.2 3 5v4.8c-1.8 1.5-3 3.7-3 6.2 0 4.4 3.6 8 8 8s8-3.6 8-8c0-2.5-1.2-4.8-3-6.2zM4 5c0-2.2 1.8-4 4-4s4 1.8 4 4v4.1C10.8 8.4 9.5 8 8 8s-2.8.4-4 1.1V5zm4 18c-3.9 0-7-3.1-7-7s3.1-7 7-7 7 3.1 7 7-3.1 7-7 7z"
    }, {
      "d": "M9.6 14.4c0-.9-.7-1.6-1.6-1.6-.9 0-1.6.7-1.6 1.6 0 .5.2.9.6 1.2V18c0 .6.4 1 1 1s1-.5 1-1v-2.4c.3-.2.6-.7.6-1.2z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconServices = {
  "id": "icon--services",
  "name": "icon--services",
  "tags": "icon--services",
  "styles": "",
  "viewBox": "0 0 23 23",
  "width": "23",
  "height": "23",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M20.5 9c-1.4 0-2.5 1.1-2.5 2.5s1.1 2.5 2.5 2.5 2.5-1.1 2.5-2.5S21.9 9 20.5 9zm0 4c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5 1.5.7 1.5 1.5c0 .9-.7 1.5-1.5 1.5zM5 11.5C5 10.1 3.9 9 2.5 9S0 10.1 0 11.5 1.1 14 2.5 14 5 12.9 5 11.5zM2.5 13c-.8 0-1.5-.6-1.5-1.5 0-.8.7-1.5 1.5-1.5s1.5.7 1.5 1.5c0 .9-.7 1.5-1.5 1.5zm9.5 5v-4c1.1-.2 2-1.2 2-2.5 0-1.2-.9-2.2-2-2.5V5c1.1-.2 2-1.2 2-2.5C14 1.1 12.9 0 11.5 0S9 1.1 9 2.5c0 1.2.9 2.2 2 2.5v4c-1.1.2-2 1.2-2 2.5 0 1.2.9 2.2 2 2.5v4c-1.1.2-2 1.2-2 2.5 0 1.4 1.1 2.5 2.5 2.5s2.5-1.1 2.5-2.5c0-1.2-.8-2.2-2-2.5zM10 2.5c0-.8.7-1.5 1.5-1.5s1.5.7 1.5 1.5S12.3 4 11.5 4 10 3.3 10 2.5zm0 9c0-.8.7-1.5 1.5-1.5s1.5.7 1.5 1.5-.7 1.5-1.5 1.5-1.5-.7-1.5-1.5zM11.5 22c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5 1.5.7 1.5 1.5-.7 1.5-1.5 1.5z"
    }, {
      "d": "M9 6.5C9 5.1 7.9 4 6.5 4S4 5.1 4 6.5c0 1.2.9 2.2 2 2.5v5.1c-1.1.2-2 1.2-2 2.5S5.1 19 6.5 19 9 17.9 9 16.5c0-1.2-.9-2.2-2-2.5V8.9c1.1-.2 2-1.2 2-2.4zm-4 0C5 5.7 5.7 5 6.5 5S8 5.7 8 6.5 7.3 8 6.5 8 5 7.3 5 6.5zm3 10c0 .9-.7 1.5-1.5 1.5S5 17.4 5 16.5 5.7 15 6.5 15s1.5.7 1.5 1.5zm9-2.4V8.9c1.1-.2 2-1.2 2-2.5S17.9 4 16.5 4 14 5.1 14 6.5c0 1.2.9 2.2 2 2.5v5.1c-1.1.2-2 1.2-2 2.5 0 1.4 1.1 2.5 2.5 2.5S19 18 19 16.6c0-1.3-.8-2.3-2-2.5zm-2-7.6c0-.8.7-1.5 1.5-1.5s1.5.7 1.5 1.5S17.3 8 16.5 8 15 7.3 15 6.5zM16.5 18c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5 1.5.7 1.5 1.5-.7 1.5-1.5 1.5z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconSettings = {
  "id": "icon--settings",
  "name": "icon--settings",
  "tags": "icon--settings",
  "styles": "",
  "viewBox": "0 0 24 24",
  "width": "24",
  "height": "24",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M21.2 12c0-.5 0-1-.1-1.4L24 8l-2.5-4.1L18 5.1c-.8-.7-1.8-1.3-2.9-1.7L14.4 0H9.6l-.8 3.4c-1.1.4-2 1-2.9 1.7L2.5 3.9 0 8l2.9 2.6c-.1.4-.1.9-.1 1.4 0 .5 0 1 .1 1.4L0 16l2.5 4.1L6 18.9c.8.7 1.8 1.3 2.9 1.7l.7 3.4h4.8l.8-3.4c1.1-.4 2-1 2.9-1.7l3.5 1.1 2.4-4-2.9-2.6c.1-.4.1-.9.1-1.4zM12 15c-1.7 0-3-1.3-3-3s1.3-3 3-3 3 1.3 3 3-1.3 3-3 3z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconSettingsGlyph = {
  "id": "icon--settings--glyph",
  "name": "icon--settings--glyph",
  "tags": "icon--settings--glyph",
  "styles": "",
  "viewBox": "-1 2 16 16",
  "width": "16",
  "height": "16",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M13.1 10c0-.3 0-.6-.1-1l2-1.7-1.7-2.7-2.3.8c-.6-.5-1.2-.9-1.9-1.1L8.6 2H5.4l-.5 2.2c-.7.3-1.4.7-1.9 1.2L.7 4.6-1 7.3.9 9c0 .3-.1.6-.1 1s0 .6.1 1L-1 12.7l1.7 2.7 2.3-.8c.6.5 1.2.9 1.9 1.1l.5 2.3h3.2l.5-2.2c.7-.3 1.3-.6 1.9-1.1l2.3.8 1.7-2.7-1.9-1.8v-1zM7 12c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconStart = {
  "id": "icon--start",
  "name": "icon--start",
  "tags": "icon--start",
  "styles": "",
  "viewBox": "0 0 21 24",
  "width": "21",
  "height": "24",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M0 24l21-12L0 0z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconStartGlyph = {
  "id": "icon--start--glyph",
  "name": "icon--start--glyph",
  "tags": "icon--start--glyph",
  "styles": "",
  "viewBox": "0 0 16 16",
  "width": "16",
  "height": "16",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zM5 11V5l6.6 3L5 11z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconStartOutline = {
  "id": "icon--start--outline",
  "name": "icon--start--outline",
  "tags": "icon--start--outline",
  "styles": "",
  "viewBox": "0 0 24 24",
  "width": "24",
  "height": "24",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M8 17l9-5-9-5z"
    }, {
      "d": "M12 2c5.5 0 10 4.5 10 10s-4.5 10-10 10S2 17.5 2 12 6.5 2 12 2zm0-2C5.4 0 0 5.4 0 12s5.4 12 12 12 12-5.4 12-12S18.6 0 12 0z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconStop = {
  "id": "icon--stop",
  "name": "icon--stop",
  "tags": "icon--stop",
  "styles": "",
  "viewBox": "0 0 24 24",
  "width": "24",
  "height": "24",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M0 0h24v24H0z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconStopGlyph = {
  "id": "icon--stop--glyph",
  "name": "icon--stop--glyph",
  "tags": "icon--stop--glyph",
  "styles": "",
  "viewBox": "0 0 16 16",
  "width": "16",
  "height": "16",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zm3 11H5V5h6v6z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconStopOutline = {
  "id": "icon--stop--outline",
  "name": "icon--stop--outline",
  "tags": "icon--stop--outline",
  "styles": "",
  "viewBox": "0 0 24 24",
  "width": "24",
  "height": "24",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M8 8h8v8H8z"
    }, {
      "d": "M12 2c5.5 0 10 4.5 10 10s-4.5 10-10 10S2 17.5 2 12 6.5 2 12 2zm0-2C5.4 0 0 5.4 0 12s5.4 12 12 12 12-5.4 12-12S18.6 0 12 0z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconStorage = {
  "id": "icon--storage",
  "name": "icon--storage",
  "tags": "icon--storage",
  "styles": "",
  "viewBox": "0 0 24 24",
  "width": "24",
  "height": "24",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M11.9 1.3c5.4 0 9.3 1 10.6 1.7-1.3.7-4.9 1.6-10.6 1.6-5.6 0-9.1-1-10.3-1.6 1.1-.7 4.7-1.7 10.3-1.7zm0-1.3C5.1 0 0 1.4 0 3s5.1 3 11.9 3C18.7 6 24 4.6 24 3s-5.4-3-12.1-3zm.1 18c-4.5 0-12-.7-12-3.2V12h1.2v2.9c0 .5 3.3 2 10.8 2 7.1 0 10.8-1.4 10.8-2V12H24v2.9c0 2.4-7.5 3.1-12 3.1zm0 6c-4.5 0-12-.7-12-3.2V18h1.2v2.8c0 .5 3.3 2 10.8 2 7.1 0 10.8-1.4 10.8-2V18H24v2.8c0 2.5-7.5 3.2-12 3.2zm0-12c-4.4 0-12-.7-12-3.2V6h1.2v2.8c0 .5 3.3 2 10.8 2 7.5 0 10.8-1.4 10.8-2V6H24v2.8c0 2.5-7.5 3.2-12 3.2z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconSubtractGlyph = {
  "id": "icon--subtract--glyph",
  "name": "icon--subtract--glyph",
  "tags": "icon--subtract--glyph",
  "styles": "",
  "viewBox": "0 0 16 16",
  "width": "16",
  "height": "16",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zm4 7v2H4V7"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconUnlocked = {
  "id": "icon--unlocked",
  "name": "icon--unlocked",
  "tags": "icon--unlocked",
  "styles": "",
  "viewBox": "0 0 18 24",
  "width": "18",
  "height": "24",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M9 6.5c-1.6 0-3.1.4-4.4 1.2V6.5c0-2.3 2-4.4 4.4-4.4 1.2 0 2.3.5 3.1 1.3l1.5-1.5C12.4.8 10.8 0 9 0 5.5 0 2.5 3 2.5 6.5v3C1.1 11 .3 13 .3 15.3.3 20.1 4.2 24 9 24c4.8 0 8.7-3.9 8.7-8.7 0-4.8-3.9-8.8-8.7-8.8zm4 11.3l-1.5 1.5L9 16.8l-2.5 2.5L5 17.8l2.5-2.5L5 12.8l1.5-1.5L9 13.7l2.5-2.5 1.5 1.6-2.5 2.5 2.5 2.5z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconUpload = {
  "id": "icon--upload",
  "name": "icon--upload",
  "tags": "icon--upload",
  "styles": "",
  "viewBox": "0 0 24 24",
  "width": "24",
  "height": "24",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M5 6.6l1.2 1.1L11 3v13h2V3l4.8 4.7L19 6.6 12 0z"
    }, {
      "d": "M22 14v6H2v-6H0v10h24V14z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconUser = {
  "id": "icon--user",
  "name": "icon--user",
  "tags": "icon--user",
  "styles": "",
  "viewBox": "0 0 32 32",
  "width": "32",
  "height": "32",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M16 6.4c3.9 0 7 3.1 7 7s-3.1 7-7 7-7-3.1-7-7 3.1-7 7-7zm0-2c-5 0-9 4-9 9s4 9 9 9 9-4 9-9-4-9-9-9z"
    }, {
      "d": "M16 0C7.2 0 0 7.2 0 16s7.2 16 16 16 16-7.2 16-16S24.8 0 16 0zm7.3 24.3H8.7c-1.2 0-2.2.5-2.8 1.3C3.5 23.1 2 19.7 2 16 2 8.3 8.3 2 16 2s14 6.3 14 14c0 3.7-1.5 7.1-3.9 9.6-.6-.8-1.7-1.3-2.8-1.3z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconWarning = {
  "id": "icon--warning",
  "name": "icon--warning",
  "tags": "icon--warning",
  "styles": "",
  "viewBox": "0 0 24 21",
  "width": "24",
  "height": "21",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M12 0L0 21h24L12 0zm0 3l9 16H3l9-16z"
    }, {
      "d": "M11.2 8.4V10l.4 4h.8l.4-4V8.4zM11.2 16a.8.8 0 1 1 1.6 0 .8.8 0 1 1-1.6 0"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconWarningGlyph = {
  "id": "icon--warning--glyph",
  "name": "icon--warning--glyph",
  "tags": "icon--warning--glyph",
  "styles": "",
  "viewBox": "0 0 16 16",
  "width": "16",
  "height": "16",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M8 1L0 15h16L8 1zm-.8 5h1.5v1.4L8.3 11h-.8l-.4-3.6V6h.1zm.8 8c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconWatson = {
  "id": "icon--watson",
  "name": "icon--watson",
  "tags": "icon--watson",
  "styles": "",
  "viewBox": "0 0 24 22",
  "width": "24",
  "height": "22",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M16.3 5.9c-2-1.1-4.3-1.5-6.5-.9-.3.1-.5.5-.4.8.1.3.4.5.8.4 1-.3 2.1-.3 3.1-.1-1.6.8-3.4 2.7-4.9 5.2-.5.9-1 1.9-1.3 2.9-.4-.4-.7-.8-1-1.2-.8-1.3-.9-2.4-.5-3.2.5-.8 1.6-1.3 3.2-1.2.3 0 .6-.3.7-.6 0-.3-.3-.6-.6-.7-2.1-.2-3.6.5-4.4 1.8-.7 1.2-.5 2.8.5 4.4.4.7 1 1.3 1.6 2-.1.5-.2 1-.3 1.4V18c-.7-.9-1.2-1.9-1.5-3-.1-.3-.4-.5-.8-.5-.3.1-.5.4-.5.8.6 2.3 2 4.3 4.1 5.5C9 21.6 10.5 22 12 22c3 0 5.9-1.5 7.5-4.3 2.4-4.1.9-9.4-3.2-11.8zm-6.9 6c2.2-3.8 5-5.6 6.2-4.9 3.5 2 4.7 6.6 2.7 10.1-1 1.7-4.8 1.5-8.3-.5-.8-.4-1.5-1-2.1-1.5.5-1 .9-2.1 1.5-3.2zm-1.1 7.9c-.6-.3-.9-1.3-.7-2.7 0-.2.1-.4.1-.6l1.8 1.2c2.1 1.2 4.2 1.8 6 1.8h.6c-2.2 1.5-5.3 1.7-7.8.3zM3.2 7.6L.9 6.3c-.3-.2-.6-.1-.8.2-.2.3-.1.7.2.8l2.3 1.3c.1.1.2.1.3.1.2 0 .4-.1.5-.3.2-.3.1-.7-.2-.8zM12 3.5c.3 0 .6-.3.6-.6V.6c0-.3-.3-.6-.6-.6s-.6.3-.6.6v2.2c0 .4.3.7.6.7zm5 1.3c.1.1.2.1.3.1.2 0 .4-.1.5-.3l1.2-2c.2-.3.1-.7-.2-.8-.3-.2-.7-.1-.9.2l-1.2 2c-.1.2 0 .6.3.8zm-10 0c-.1 0-.2.1-.3.1-.2 0-.4-.1-.5-.3L5 2.6c-.1-.3 0-.7.3-.9.3-.2.7-.1.9.2l1.2 2c0 .3-.1.7-.4.9zm16.9 1.7c-.2-.3-.6-.4-.9-.2l-2.3 1.3c-.3.2-.4.6-.2.9.1.2.3.3.5.3.1 0 .2 0 .3-.1l2.3-1.3c.4-.2.5-.6.3-.9z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};
export var iconWhisk = {
  "id": "icon--whisk",
  "name": "icon--whisk",
  "tags": "icon--whisk",
  "styles": "",
  "viewBox": "0 0 25 16",
  "width": "25",
  "height": "16",
  "svgData": {
    "circles": "",
    "ellipses": "",
    "paths": [{
      "d": "M9.9 9.7L4.5 0 0 8l4.5 8h8l.5-.8 3-5.5H9.9zm-4.7 5.1L1.4 8l3.1-5.5 6.9 12.3H5.2zm7.2-1.1l-1.6-2.8h3.1l-1.5 2.8z"
    }, {
      "d": "M19.5 0h-7.8l-.6 1.1-3 5.5h6l5.3 9.5L24 8l-4.5-8zm-9.3 5.3l1.5-2.8 1.6 2.8h-3.1zm2.4-4.1h6.2L22.6 8l-3.1 5.5-6.9-12.3z"
    }],
    "polygons": "",
    "polylines": "",
    "rects": ""
  }
};